module.exports = __webpack_public_path__ + "static/media/testing.56d3d787.svg";